import { EDITOR_TOGGLE_CREATE_PAGE } from './constants';

export function toggleCreatePage(args) {
  return {
    type: EDITOR_TOGGLE_CREATE_PAGE,
    data: args,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_TOGGLE_CREATE_PAGE:
      return {
        ...state,
        showCreatePage: !state.showCreatePage,
        selectedPage: action.data,
        showBuilderCanvasLoader: !state.showBuilderCanvasLoader,
      };

    default:
      return state;
  }
}
